import "./post_thai.css";
import img1 from "../../../assets/thai/บุตร_หลาน.png";
import img2 from "../../../assets/thai/คู่สมรส.png";
import { Helmet } from "react-helmet";

const MainContent = () => {
  const TITLE = "ทายาทในกองมรดกสามารถเป็นใครได้บ้าง";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ทายาทตามประมาลกฎหมายแพ่งและพาณิชย์ มาตรา
          1603 ได้บัญญัติว่า
          "กองมรดกย่อมตกทอดแก่ทายาทโดยสิทธิตามกฎหมายหรือโดยพินัยกรรม"
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>
            ทายาทที่มีสิทธิตามกฎหมาย เรียกว่า "<u>ทายาทโดยธรรม</u>"
          </b>
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>
            ทายาทที่มีสิทธิตามพินัยกรรม เรียกว่า "<u>ผู้รับพินัยกรรม</u>"
          </b>
        </p>

        {/* 1. ทายาทโดยธรรม */}
        <h2 id="initial-header">1. ทายาทโดยธรรม</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เป็นบุคคลที่กฎหมายกำหนดให้มีสิทธิได้รับมรดกของผู้ตาย
          เมื่อเจ้ามรดกถึงแก่ความตายโดยไม่ได้ทำพินัยกรรมไว้ ซึ่งจะแบ่งออกเป็น 2
          พวก คือ ทายาทโดยธรรมที่เป็นญาติ และทายาทโดยธรรมที่เป็นคู่สมรส
        </p>

        {/* 6 ลำดับทายาท */}
        <div>
          <h3 id="second-header">1.1 ทายาทโดยธรรมที่เป็นญาติ</h3>
          <p className="ml-4">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <mark className=" bg-[#fee9b2] rounded-xl">
              ทายาทโดยธรรมที่เป็นญาติ มีเพียง 6 ลำดับเท่านั้น
            </mark>{" "}
            หากมีทายาทลำดับไหนมีสิทธิรับมรดกก่อน ก็จะจัดแบ่งมรดกเลย
            จะไม่ตกทอดถึงทายาทลำดับถัดไป <u>ยกเว้น</u> ลำดับที่ 1 และ 2
            จะสามารถรับมรดกร่วมกันได้ ในสัดส่วนเท่ากัน
          </p>

          <h4 id="third-header">ลำดับที่ 1 ผู้สืบสันดาน</h4>
          <p className="ml-8">
            &nbsp;&nbsp;&nbsp;&nbsp;หมายถึง{" "}
            <mark className=" bg-[#fee9b2] rounded-xl">
              ผู้สืบสายโลหิตโดยตรง
            </mark>{" "}
            ลงมาทุกชั้นของเจ้ามรดก เช่น บุตร หลาน เหลน เป็นต้น
            แต่ไม่ได้หมายความว่าผู้สืบสันดานทุกคนจะได้รับมรดกเท่า ๆ กัน
            ผู้สืบสันดานที่จะได้รับมรดกจากเจ้ามรดกนั้นจะต้องอยู่ในชั้นสนิทสุดกับเจ้ามรดก
            ผู้สืบสันดานชั้นถัดไปจะรับมรดกได้ต้องอาศัยการรับมรดกแทนที่เท่านั้น{" "}
            <br /> &nbsp;&nbsp;&nbsp;&nbsp;
            <u>โดยบุตรที่ถือว่าเป็นผู้สืบสันดานของเจ้ามรดก</u> มี 3 ประเภท คือ
            บุตรที่ชอบด้วยกฎหมาย บุตรนอกกฎหมายที่บิดารองรับ และบุตรบุญธรรม
            <br /> &nbsp;&nbsp;&nbsp;&nbsp;<u>ตัวอย่างเช่น</u>{" "}
            นายดำมีบุตรชอบด้วยกฎหมาย 3 คน ตือนายหนึ่ง นายสอง และนายสาม
            และนายหนึ่งมีบุตรที่ชอบด้วยกฎหมาย 1 คน คือ ด.ช. เอก
            ต่อมานายหนึ่งตายไปก่อน นายดำตาย เมื่อนายดำตายไปและมีมรดก 3 ล้านบาท
            มรดกจะตกแก่ นายหนึ่ง นายสอง และนายสาม คนละเท่า ๆ กัน คือคนละ 1
            ล้านบาท แต่นายหนึ่งซึ่งเป็นผู้สืบสันดานของนายดำได้ตายไปก่อนนายดำ
            แต่นายหนึ่งมี ด.ช. เอกเป็นบุตรชอบด้วยกฎหมาย และเป็นหลานของนายดำ
            ถือว่า ด.ช. เอกเป็นผู้สืบสันดานโดยตรงของนายหนึ่ง
            สามารถเข้ารับมรดกแทนที่นายหนึ่งได้ ดังนั้น มรดกของนายดำจะตกแก่ ด.ช.
            เอก นายสอง นายสาม คนละเท่า ๆ กัน คือคนละ 1 ล้านบาท
            สามารถอธิบายได้ตามแผนภาพล่างนี้
            <img
              src={img1}
              alt="บุตร_หลาน"
              className="w-11/12 block ml-auto mr-auto"
            />
          </p>

          <h4 id="fourth-header">ลำดับที่ 2 บิดามารดา</h4>
          <p className="ml-8">
            &nbsp;&nbsp;&nbsp;&nbsp;
            <mark className=" bg-[#fee9b2] rounded-xl">
              บิดามารดาที่สามารถรับมรดกของเจ้ามรดกได้
              ต้องเป็นบิดามารดาที่ชอบด้วยกฎหมายเท่านั้น
            </mark>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;• <b>สำหรับมารดาผู้ให้กำเนิด</b>{" "}
            ไม่ว่ามารดาจะมีคู่สมรสที่ชอบด้วยกำหมายหรือไม่นั้น เมื่อบุตรแล้ว
            บุตรนั้นจะเป็นบุตรชอบด้วยกฎหมายของหญิงเสมอ ดังนั้น เมื่อบุตรตาย
            มารดาผู้ให้กำเนิด ย่อมเป็นทายาทโดยธรรมลำดับที่สองของบุตรเสมอ
            เพราะเป็นมารดาที่ชอบด้วยกฎหมาย
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;• <b>สำหรับบิดาที่ชอบด้วยกฎหมาย</b>{" "}
            คือผู้ที่สมรสกับมารดาตามกฎหมาย
            รวมถึงบิดาที่เข้ามามีความสัมพันธ์ต่อบุตรภายหลังบุตรเกิดเท่านั้น
            ถึงจะมีสิทธิได้รับมรดกของบุตรที่ชอบด้วยกฎหมาย
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;• <b>
              สำหรับบิดาที่รับรองบุตรนอกกฎหมาย
            </b>{" "}
            ถึงแม้ว่าบิดาจะมีต่อบุตรแบบเปิดเผย
            ให้บุตรเป็นบุตรนอกกฎหมายที่บิดารองรับแล้วก็ตาม
            แต่ไม่ทำให้บิกาเป็นบิดาที่ชอบด้วยกฎหมายของบุตรได้ ดังนั้น เมื่อ
            บุตรตายบิดาที่รับรองบุตรนอกกฎหมายนั้นไม่มีสิทธิรับมรดกของบุตรเพราะบิดาที่ไม่ชอบด้วยกฎหมายไม่ถือเป็นทายาทโดยธรรมลำดับที่สอง
          </p>

          <h4 id="fifth-header">ลำดับที่ 3 พี่น้องร่วมบิดามารดาเดียวกัน</h4>
          <p className="ml-8">
            &nbsp;&nbsp;&nbsp;&nbsp; พี่น้องร่วมบิดามารดาเดียวกัน
            ต้องเป็นพี่น้องที่ถือกำเนิดจากบิดามารดาเดียวกันเท่านั้น
            ถ้าพี่น้องถือกำเนิดคนละมารดา
            หรือคนละบิดาของผู้ตายถือว่าไม่จัดอยู่ในลำดับที่ 3
            จะจัดอยู่ในลำดับที่ 4 คือพี่น้องร่วมบิดาหรือมารดาเดียวกัน
          </p>

          <h4 id="sixth-header">ลำดับที่ 4 พี่น้องร่วมบิดาหรือมารดาเดียวกัน</h4>
          <p className="ml-8">
            &nbsp;&nbsp;&nbsp;&nbsp;
            พี่น้องร่วมบิดาหรือมารดาเดียวกันจะเป็นพี่น้องที่ถือกำเนิดคนละมารดา
            หรือคนละบิดาของผู้ตาย ซึ่งจะแยกออกเป็น 2 กรณี คือ <br />
            &nbsp;&nbsp;&nbsp;&nbsp;• <b>
              กรณีที่พี่น้องร่วมมารดาเดียวกัน
            </b>{" "}
            จะไม่เกิดปัญหาอะไร เพราะกฎหมายได้กำหนดว่า
            มารดาผู้ให้กำเนิดจะเป็นมารดาที่ชอบด้วยกฎหมายเสมอ <br />
            &nbsp;&nbsp;&nbsp;&nbsp;• แต่ถ้าเป็น{" "}
            <b>กรณีที่พี่น้องร่วมบิดาเดียวกัน</b>{" "}
            บิดาอาจจะเป็นบิดาที่ชอบด้วยกฎหมายหรือไม่ชอบกฎหมายก็ได้
          </p>

          <h4 id="seventh-header">ลำดับที่ 5 ปู่ ย่า ตา ยาย</h4>
          <p className="ml-8">
            &nbsp;&nbsp;&nbsp;&nbsp;หมายถึง บุพการีโดยตรงขึ้นไปเท่านั้น ได้แก่
            บิดา มารดาของบิดา หรือของมารดา โยไม่รวมพี่น้องร่วมบิดามารดาของ ปู่
            ย่า ตา ยาย ซึ่งมักจะเรียกว่า ปู่ ย่า ตา ยาย เช่นกัน แต่ในแง่ของ ปู่
            ต้องเป็นบิดาโดยชอบกฎหมายของบิดาเจ้ามรดก และตา
            ต้องเป็นบิดาโดยชอบกฎหมายของมารดาเจ้ามรดกเช่นกัน
          </p>

          <h4 id="eighth-header">ลำดับที่ 6 ลุง ป้า น้า อา</h4>
          <p className="ml-8">
            &nbsp;&nbsp;&nbsp;&nbsp;ลุง ป้า น้า อา
            นั้นไม่ได้แยกความใกล้ชิดสนิทกันอย่างพี่น้องร่วมบิดามารดาเดียวกัน
            หรือพี่น้องร่วมบิดาหรือมารดาเดียวกัน
            แต่เพียงต้องเป็นสายเลือดเดียวกันของผู้ตายเท่านั้น
          </p>
        </div>

        {/* คู่สมรส */}
        <h3 id="ninth-header">1.2 ทายาทโดยธรรมที่เป็นคู่สมรส</h3>
        <p className="ml-4">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <mark className=" bg-[#fee9b2] rounded-xl">
            คู่สมรสที่มีสิทธิรับมรดกได้นั้นต้องเป็นคู่สมรสที่ชอบด้วยกฎหมาย
            คือต้องจดทะเบียนสมรสกันเท่านั้น
          </mark>{" "}
          แต่การอยู่กินฉันสามี ภรรยา เป็นเวลาหลายสิบปีโดยไม่ได้จดทะเบียนสมรส
          ไม่ถือว่าเป็นคู่สมรสโดยชอบด้วยกฎหมาย
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;คู่สมรส จะมีสิทธิรับมรดกเสมอ
          แต่ได้รับมากน้อบเพียงใดนั้น จะขึ้นอยู่กับว่า
          ต้องรับมรดกร่วมกับทายาทโดยธรรมที่เป็นญาติในลำดับใด
          โดยจะมีส่วนแบ่งมรดกดังตารางล่างนี้
          <br />
          <br />
          <table className=" w-full">
            <tr>
              <th>ลำดับ</th>
              <th>ประเภทญาติ</th>
              <th>ส่วนแบ่งของคู่สมรส</th>
            </tr>

            {/* 1 */}
            <tr>
              <td>1</td>
              <td>ผู้สืบสันดาน</td>
              <td>ได้รับส่วนแบ่งเท่ากัน</td>
            </tr>

            {/* 2 */}
            <tr>
              <td>2</td>
              <td>บิดามารดา</td>
              <td>กึ่งหนึ่ง</td>
            </tr>

            {/* 3 */}
            <tr>
              <td>3</td>
              <td>พี่น้องร่วมบิดามารดาเดียวกัน</td>
              <td>กึ่งหนึ่ง</td>
            </tr>

            {/* 4 */}
            <tr>
              <td>4</td>
              <td>พี่น้องร่วมบิดาหรือมารดาเดียวกัน</td>
              <td>2 ใน 3</td>
            </tr>

            {/* 5 */}
            <tr>
              <td>5</td>
              <td>ปู่ ย่า ตา ยาย</td>
              <td>2 ใน 3</td>
            </tr>

            {/* 6 */}
            <tr>
              <td>6</td>
              <td>ลุง ป้า น้า อา</td>
              <td>2 ใน 3</td>
            </tr>

            {/* 6 */}
            <tr>
              <td></td>
              <td>ไม่มีทายาท</td>
              <td>ได้รับมรดกทั้งหมด</td>
            </tr>
          </table>
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;***
          กรณีที่เจ้ามรดกมีทายาททั้งลำดับที่ 1 และลำดับที่ 2 ร่วมกัน
          คู่สมรสก็จะได้รับมรดกส่วนแบ่งเท่า ๆ กัน หรือ หารเท่า
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<u>ตัวอย่างเช่น</u> เจ้ามรดกมีมรดก
          1 ล้านบาท โดยมีทายาทเป็นคู่สมรส บุตร บิดาและมารดา ทั้งหมด 4 คน
          ทำให้การแบ่งมรดกต้องเอามาหาร 4 นั้นเอง เพราะบุตรอยู่ในลำดับที่ 1
          และบิดามารดาอยู่ในลำดับที่ 2 ทำให้แต่ละคนจะได้มรดกคนละ 250000 บาท
          <img
            src={img2}
            alt="บุตร_หลาน"
            className="w-11/12 block ml-auto mr-auto"
          />
        </p>

        {/* 2. ผู่รับพินัยกรรม */}
        <h2 id="tenth-header">2. ผู้รับพินัยกรรม</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เมื่อเจ้ามรดกทำพินัยกรรมยกทรัพย์สินให้แก่ผู้รับพินัยกรรม
          ถ้าพินัยกรรมนั้นสมบูรณ์
          และตอนเจ้ามรดกเสียชีวิตทรัพย์สินที่เจ้ามรดกได้ทำพินัยกรรมไว้จะตกแก่ผู้รับพินัยกรรมทันที
          ซึ่งผู้รับพินัยกรรมไม่จำเป็นต้องเป็นญาติของเจ้ามรดกเท่านั้น
          อาจเป็นบุคคลอื่น ๆ ก็ได้
        </p>
      </div>

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
          <li>
            <a className="text-indigo-700 underline" href="/thai/2">
              ผู้จัดการมรดกคือใคร ใครสามารถเป็นได้บ้าง ?
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/thai/3">
              กรณีใดบ้างที่สามารถรับมรดกแทนที่กันได้
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/thai/6">
              รูปแบบพินัยกรรม ใครสามารถทำพินัยกรรมได้บ้าง ?
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default MainContent;
